/** Etiquetas por defecto si el catálogo API no está disponible. */
export const DIFICULTAD_LABELS_FALLBACK = {
  1: 'Fácil',
  2: 'Intermedio',
  3: 'Difícil',
};

export const HABILIDAD_LABELS_FALLBACK = {
  1: 'Aplicar',
  2: 'Comprender',
  3: 'Analizar',
  4: 'Recordar',
};

export function isNumericId(value) {
  if (value == null || value === '') return false;
  return /^\d+$/.test(String(value).trim());
}

/** Construye mapa id → glosa desde listados del API (Habilidad, Dificultad, etc.). */
export function buildIdGlosaMap(list) {
  const byId = {};
  for (const item of list || []) {
    const id = Number(
      item.Id ?? item.id ?? item.id_habilidad ?? item.id_dificultad ?? item.IdHabilidad ?? item.IdDificultad
    );
    const glosa = String(
      item.Glosa ?? item.glosa ?? item.glosa_habilidad ?? item.glosa_dificultad ?? ''
    ).trim();
    if (Number.isFinite(id) && id > 0 && glosa) {
      byId[id] = glosa;
    }
  }
  return byId;
}

/**
 * Muestra el nombre de catálogo: usa glosa si ya es texto; si es id numérico, resuelve con byId/fallback.
 */
export function resolveCatalogDisplay({ glosa, id, byId = {}, fallback = {} }) {
  const merged = { ...fallback, ...byId };
  const glosaStr = glosa != null && glosa !== '' ? String(glosa).trim() : '';
  if (glosaStr && !isNumericId(glosaStr)) {
    return glosaStr;
  }
  const idVal = id != null && id !== '' ? id : (isNumericId(glosaStr) ? glosaStr : null);
  if (idVal == null || idVal === '') return '—';
  const n = Number(idVal);
  if (Number.isFinite(n) && merged[n]) {
    return merged[n];
  }
  return glosaStr || String(idVal);
}
